import { Typography, useMediaQuery, useTheme } from "@mui/material";

const SectionTitle = (props) => {
    const theme = useTheme();
    const mediumScreen = useMediaQuery(theme => theme.breakpoints.up("md"));
    const typoHeading = mediumScreen ? "h3" : "h4";

    return (
        <Typography {...props} variant={props.variant ? props.variant : typoHeading} color={(props.color) ? props.color : theme.palette.common.black} mb={(props.mb) ? props.mb : 5}>
            {
                props.highlight ? (
                    <>{props.normal} <span style={{color:theme.palette.primary.main}}>{props.highlight}</span></>
                ) : (
                    <>{props.normal}</>
                )
            }
        </Typography>
    )
}

export default SectionTitle;